module.exports = __webpack_public_path__ + "img/Subtract.fa22c67c.svg";